"use client";
import { rem } from "../../../../utils/units-converters/rem.mjs";
//#region packages/@mantine/core/src/core/Box/style-props/resolvers/radius-resolver/radius-resolver.ts
function radiusResolver(value, theme) {
	if (typeof value === "string" && value in theme.radius) return `var(--mantine-radius-${value})`;
	if (typeof value === "number") return rem(value);
	if (typeof value === "string") return rem(value);
	return value;
}
//#endregion
export { radiusResolver };

//# sourceMappingURL=radius-resolver.mjs.map